import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _0d62f55c = () => interopDefault(import('../../../pages/search.vue' /* webpackChunkName: "pages/search" */))
const _1ba7c6dc = () => interopDefault(import('../../../pages/style-guide.vue' /* webpackChunkName: "pages/style-guide" */))
const _72a8523f = () => interopDefault(import('../../../pages/collections/_collection.vue' /* webpackChunkName: "pages/collections/_collection" */))
const _6f4db9d6 = () => interopDefault(import('../../../pages/learn/_article.vue' /* webpackChunkName: "pages/learn/_article" */))
const _80c07670 = () => interopDefault(import('../../../pages/press/_release.vue' /* webpackChunkName: "pages/press/_release" */))
const _34240f8e = () => interopDefault(import('../../../pages/products/_product/_variant.vue' /* webpackChunkName: "pages/products/_product/_variant" */))
const _626ed8be = () => interopDefault(import('../../../pages/_tower.vue' /* webpackChunkName: "pages/_tower" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/search",
    component: _0d62f55c,
    name: "search"
  }, {
    path: "/style-guide",
    component: _1ba7c6dc,
    name: "style-guide"
  }, {
    path: "/collections/:collection?",
    component: _72a8523f,
    name: "collections-collection"
  }, {
    path: "/learn/:article",
    component: _6f4db9d6,
    name: "learn-article"
  }, {
    path: "/press/:release",
    component: _80c07670,
    name: "press-release"
  }, {
    path: "/products/:product?/:variant?",
    component: _34240f8e,
    name: "products-product-variant"
  }, {
    path: "/:tower*",
    component: _626ed8be,
    name: "tower"
  }],

  parseQuery: function(queryString) {
        return require('qs').parse(queryString);
      },
  stringifyQuery: function(object) {
        var queryString;
        queryString = require('qs').stringify(object);
        if (queryString) {
          return '?' + queryString;
        } else {
          return '';
        }
      },
  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
